
export default {
	name: 'booleanValue',
	handler: {
		init: function (element, valueAccessor, allBindingsAccessor) {
			let observable = valueAccessor();
			let interceptor = ko.computed({
				read: function () {
					return observable().toString();
				},
				write: function (newValue) {
					observable(newValue === 'true');
				}
			});

			ko.applyBindingsToNode(element, { value: interceptor });
		}
	}
};
